import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/SectionMenu.css';
import IconDildo from '../icon/DildoIcon(Color).svg';
import IconGrinder from '../icon/GrinderIcon(Color).svg';
import IconMasturbator from '../icon/MastubartorsIcon(Color).svg';
import IconSheath from '../icon/SheathIcon(Color).svg';
import IconTunnel from '../icon/TunnelPlugIcon(Color).svg';
import IconAccessories from '../icon/accessories.svg';
import IconMerchandise from '../icon/shirt-solid.svg';
import { useTranslation } from 'react-i18next';

const SectionMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Add event listener for clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && event.target.id !== 'toggleButton') {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const scrollToSection = (section) => {
    navigate(`/products#${section}`);
    setTimeout(() => {
      const anchor = document.querySelector(`#${section}`);
      if (anchor) {
        const headerOffset = 190;
        const elementPosition = anchor.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY  - headerOffset;
  
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
    closeMenu();
  };
  
  return (
    <div class="menu-width">
      <div class="elevated-product-header-container">
        <div class="products-header-content">
          <div class="header-section">
            <div class="section-bouton">
              <div id="toggleButton" class="section-text" onClick={toggleMenu}>
                  Sections
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class={`menu-section ${isOpen ? 'show' : ''}`} ref={menuRef}>
              <div class="product-selection-section" onClick={() => scrollToSection('dildos')}>
                <img class="product-header-icon-dildo" src={IconDildo} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">{t('categories.dildosCategory')}</p>
              </div>
              
              {/* <div class="product-selection-section" onClick={() => scrollToSection('plugs')}>
                <img class="product-header-icon" src={IconTunnel} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">Tunnels</p>
              </div> */}
              
              <div class="product-selection-section" onClick={() => scrollToSection('masturbators')} >
                <img class="product-header-icon" src={IconMasturbator} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">{t('categories.masturbatorsCategory')}</p>
              </div>
              
              {/* <div class="product-selection-section" onClick={() => scrollToSection('wearable')} >
                <img class="product-header-icon" src={IconSheath} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">Wearables</p>
              </div> */}
              
              {/* <div class="product-selection-section" onClick={() => scrollToSection('grinder')} >
                <img class="product-header-icon" src={IconGrinder} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">Grinders</p>
              </div> */}
              
              <div class="product-selection-section" onClick={() => scrollToSection('accessories')} >
                <img class="product-header-icon-accessories" src={IconAccessories} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">{t('categories.accessoriesCategory')}</p>
              </div>
              
              <div class="product-selection-section"  onClick={() => scrollToSection('merchandise')}>
                <img class="product-header-icon-merchandise" src={IconMerchandise} alt="header-logo"/>
                <p class="product-header-component product-header-mobile">{t('categories.merchandiseCategory')}</p>
              </div>
              
          </div>
    </div>
  );
};

export default SectionMenu;
